export const poWorkspaceEn = {
  unitReviewHint:
    "Changing the purchase unit clears its price. Enter a price for the new unit before saving.",
  po_currency_prices_required:
    "Changing currency requires reviewing and re-entering every purchase price.",
  allCreated: "All supplier groups already have purchase orders",
  manual: "Create manually",
  fromPi: "Create from PI",
  buildHint:
    "Select a PI, review each supplier group and confirm purchase prices before creating orders.",
  linkOnlyHint:
    "Optional reference only. Linking a PI here does not copy its items. To copy items by supplier, choose Create from PI.",
  previewGroups: "Review supplier groups",
  createGroups: "Create {{count}} purchase orders",
  priceRequired: "Enter purchase price",
  lot: "LOT",
  lineHint:
    "LOT is the supplier batch on each line; leave it blank until known. A missing purchase price must be entered; enter 0 explicitly only for a free item.",
  currencyHint:
    "Currency starts from the PI. Confirm the supplier purchase currency and enter prices in that currency; no exchange conversion is applied.",
  alreadyCreated: "Already created:",
  fixPreview:
    "Complete missing purchase prices and supplier assignments before creating orders.",
  previewPrint: "Print preview",
  supplierVisibleRemarks: "The supplier reads this on the printed order and the supplier portal. Leave out customer names and selling prices.",
  supplierVisibleLines: "Line descriptions and remarks are printed on the supplier copy — leave out customer names.",
  printAudience: "Which copy",
  printAudience_supplier: "Supplier copy",
  printAudience_internal: "Internal copy (PI, RFQ, requisition numbers)",
  printAudienceInternalHint: "Keep the internal copy inside the company. Send the supplier copy to suppliers.",
  saveBeforePrint:
    "Save your changes before previewing the document for printing.",
  statusHint:
    "Order status tracks purchasing progress. It does not record a warehouse stock receipt.",
  supplierSnapshot: "Supplier details saved on this order",
  orderDateRequired: "Enter the order date.",
  dateFrom: "Order date from",
  dateTo: "Order date to",
  clearFilters: "Clear filters",
  po_missing_cost: "Enter a purchase price for every line.",
  po_product_unavailable:
    "A product is unavailable. Check the source PI and product catalog.",
  po_supplier_required: "Select an active supplier for every product.",
  po_preview_changed:
    "Source data changed. Refresh and review the preview before creating.",
  po_invalid_prices: "Purchase price lines are invalid. Refresh the preview.",
  po_items_required: "Add at least one item.",
  editTitle: "Edit purchase order",
  required: "Required",
  shippingFee: "Shipping cost",
  supplierPhone: "Phone",
  supplierEmail: "Email",
  supplierAddress: "Address",
  groups: {
    supplierHint: "Supplier and the contact who receives the order; the printed details are saved on the order.",
    orderHint: "Dates, delivery progress, currency and purchase terms.",
    lines: "Items",
  },
  sideShow: "Show extra columns",
  sideHide: "Hide extra columns",
  sideColumns: "Line remark",
  sideLocked: "A line uses the extra columns, so they stay visible.",
};

export const poWorkspaceVi = {
  unitReviewHint:
    "Đổi đơn vị mua sẽ xóa đơn giá. Nhập giá theo đơn vị mới trước khi lưu.",
  po_currency_prices_required:
    "Đổi tiền tệ yêu cầu kiểm tra và nhập lại tất cả đơn giá mua.",
  allCreated: "Tất cả nhóm nhà cung cấp đã có đơn mua hàng",
  manual: "Tạo thủ công",
  fromPi: "Tạo từ PI",
  buildHint:
    "Chọn PI, kiểm tra từng nhóm nhà cung cấp và xác nhận giá mua trước khi tạo đơn.",
  linkOnlyHint:
    "Chỉ liên kết tham chiếu, không tự chép dòng hàng. Để chép hàng theo nhà cung cấp, chọn Tạo từ PI.",
  previewGroups: "Xem trước các nhóm nhà cung cấp",
  createGroups: "Tạo {{count}} đơn mua hàng",
  priceRequired: "Nhập giá mua",
  lot: "LOT",
  lineHint:
    "LOT là lô nhà cung cấp theo từng dòng; để trống khi chưa có. Giá mua thiếu phải được nhập; chỉ nhập rõ 0 nếu hàng miễn phí.",
  currencyHint:
    "Tiền tệ lấy ban đầu từ PI. Xác nhận tiền tệ mua của nhà cung cấp và nhập giá theo tiền tệ đó; hệ thống không tự quy đổi.",
  alreadyCreated: "Đã tạo:",
  fixPreview:
    "Điền đủ giá mua và gán nhà cung cấp cho sản phẩm trước khi tạo đơn.",
  previewPrint: "Xem trước bản in",
  supplierVisibleRemarks: "Nhà cung cấp đọc được phần này trên bản in và Cổng nhà cung cấp. Đừng ghi tên khách hay giá bán.",
  supplierVisibleLines: "Mô tả và ghi chú dòng hàng in trên bản gửi nhà cung cấp — đừng ghi tên khách.",
  printAudience: "Bản in cho ai",
  printAudience_supplier: "Bản gửi nhà cung cấp",
  printAudience_internal: "Bản nội bộ (có số PI, RFQ, yêu cầu mua)",
  printAudienceInternalHint: "Bản nội bộ chỉ lưu trong công ty. Gửi nhà cung cấp thì dùng bản gửi nhà cung cấp.",
  saveBeforePrint: "Lưu thay đổi trước khi xem trước bản in chứng từ.",
  statusHint:
    "Trạng thái theo dõi tiến độ mua hàng; không thay thế nghiệp vụ nhập kho.",
  supplierSnapshot: "Thông tin nhà cung cấp lưu trên đơn này",
  orderDateRequired: "Nhập ngày đặt hàng.",
  dateFrom: "Ngày đặt từ",
  dateTo: "Ngày đặt đến",
  clearFilters: "Xóa bộ lọc",
  po_missing_cost: "Nhập giá mua cho tất cả dòng hàng.",
  po_product_unavailable:
    "Sản phẩm không còn khả dụng. Kiểm tra PI nguồn và danh mục sản phẩm.",
  po_supplier_required: "Chọn nhà cung cấp đang hoạt động cho mỗi sản phẩm.",
  po_preview_changed:
    "Dữ liệu nguồn đã thay đổi. Tải lại và kiểm tra bản xem trước trước khi tạo.",
  po_invalid_prices: "Dòng giá mua không hợp lệ. Tải lại bản xem trước.",
  po_items_required: "Thêm ít nhất một dòng hàng.",
  editTitle: "Sửa đơn mua hàng",
  required: "Bắt buộc",
  shippingFee: "Phí vận chuyển",
  supplierPhone: "Điện thoại",
  supplierEmail: "Email",
  supplierAddress: "Địa chỉ",
  groups: {
    supplierHint: "Nhà cung cấp và người liên hệ nhận đơn; thông tin in được lưu trên đơn.",
    orderHint: "Ngày, tiến độ giao hàng, tiền tệ và điều khoản mua.",
    lines: "Hàng hoá",
  },
  sideShow: "Hiện cột phụ",
  sideHide: "Ẩn cột phụ",
  sideColumns: "Ghi chú dòng",
  sideLocked: "Có dòng đang dùng cột phụ nên cột phụ luôn hiện.",
};

export const poWorkspaceZh = {
  unitReviewHint: "变更采购单位会清除价格。保存前请输入新单位价格。",
  po_currency_prices_required: "变更币种需要检查并重新输入所有采购价格。",
  allCreated: "所有供应商分组均已创建采购单",
  manual: "手动创建",
  fromPi: "从 PI 创建",
  buildHint: "选择 PI，检查各供应商分组并确认采购价后创建订单。",
  linkOnlyHint:
    "仅作参考关联，不会复制明细。若要按供应商复制，请选择“从 PI 创建”。",
  previewGroups: "预览供应商分组",
  createGroups: "创建 {{count}} 张采购单",
  priceRequired: "输入采购价",
  lot: "批号 LOT",
  lineHint:
    "LOT 是各明细的供应商批号；未知时留空。缺少采购价须填写；免费品才明确输入 0。",
  currencyHint:
    "币种初始取自 PI。请确认供应商采购币种并输入该币种价格；系统不自动换算汇率。",
  alreadyCreated: "已创建：",
  fixPreview: "创建前请补齐采购价与产品供应商。",
  previewPrint: "打印预览",
  supplierVisibleRemarks: "供应商可在打印件和供应商门户看到此内容。请勿填写客户名称或售价。",
  supplierVisibleLines: "行描述与备注会印在供应商版上——请勿填写客户名称。",
  printAudience: "打印版本",
  printAudience_supplier: "供应商版",
  printAudience_internal: "内部版（含 PI、询价单、采购申请编号）",
  printAudienceInternalHint: "内部版仅限公司内部保存。发给供应商请使用供应商版。",
  saveBeforePrint: "请先保存变更，再预览打印文件。",
  statusHint: "订单状态追踪采购进度，不代表仓库已入库。",
  supplierSnapshot: "此订单保存的供应商信息",
  orderDateRequired: "请输入订单日期。",
  dateFrom: "订单起始日",
  dateTo: "订单截止日",
  clearFilters: "清除筛选",
  po_missing_cost: "请输入每条明细的采购价。",
  po_product_unavailable: "产品无法使用，请检查来源 PI 与产品目录。",
  po_supplier_required: "请为每项产品选择可用供应商。",
  po_preview_changed: "来源数据已变更，请重新预览确认后创建。",
  po_invalid_prices: "采购价明细无效，请重新预览。",
  po_items_required: "请至少新增一条明细。",
  editTitle: "编辑采购单",
  required: "必填",
  shippingFee: "运费",
  supplierPhone: "电话",
  supplierEmail: "邮箱",
  supplierAddress: "地址",
  groups: {
    supplierHint: "供应商及接收订单的联系人；打印数据保存在订单上。",
    orderHint: "日期、交货进度、币种与采购条款。",
    lines: "品项",
  },
  sideShow: "显示其他字段",
  sideHide: "隐藏其他字段",
  sideColumns: "明细备注",
  sideLocked: "有明细使用其他字段，因此会一直显示。",
};
